import { render, staticRenderFns } from "./ManualSingle.vue?vue&type=template&id=1267925e&scoped=true"
import script from "./ManualSingle.vue?vue&type=script&lang=js"
export * from "./ManualSingle.vue?vue&type=script&lang=js"
import style0 from "./ManualSingle.vue?vue&type=style&index=0&id=1267925e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267925e",
  null
  
)

export default component.exports